import React from 'react';
import './index.css';

export default () => (
  <div className='about'>
    <p>
      Trivia game created by Eric Freeman.  Made with React and Redux.  Uses Open Trivia Database for questions.  All source available on my GitHub.
    </p>
  </div>
)


// WEBPACK FOOTER //
// ./src/containers/about/index.js